<div *transloco="let t">
  @if (!control().untouched && control().invalid) {
    <mat-error>
      @for (error of getErrors(control()); track error) {
        <span>{{ t('error.' + error) }}</span>
      }
    </mat-error>
  }
</div>
